import {
    userInfo
} from "os";
import http from "@/lib/http";
export const mrktCommonMixins = {
    data() {
        return {}
    },
    methods: {

        //Pdata
        getRawData() {
            this.rawData = [];
            let myself = this;
            var data = {}
            if (myself.rawDataApi === 'relativeStrengthRanking') {
                data = {
                    my_date: (myself.ddate!='')? myself.getDate(myself.ddate): '',
                    name: this.mrktFilter
                };
            } else {
                data = {
                    my_date: (myself.ddate!='')? myself.getDate(myself.ddate): '',
                    // m_filter: myself.selFilter,
                    // min_range: myself.minRange,
                    // max_range: myself.maxRange,
                    // sector: myself.sectorname
                };
            }
            http.post(
                myself.rawDataApi, data,
                (error, response) => {
                    if (response.length > 0) {
                        myself.rawData = response;
                        myself.searchData = response;
                        console.log(new Date(myself.rawData[0].date));
                        myself.ddate = new Date(myself.rawData[0].date);
                        // console.log(myself.searchData);
                    }
                }
            );
        },
        //Filter data on specific column
        filterData() {
            this.clearData();
            if (this.selFilter !== "") {
                if (this.minRange == "" && this.maxRange == "") {
                    this.rawData = this.searchData;
                    return this.rawData;
                } else {
                    this.rawData = this.searchData.filter(rd => {
                        // console.log(rd, this.selFilter);
                        if (this.minRange != "" && this.maxRange != "") {
                            return (
                                parseInt(rd[this.selFilter]) >= parseInt(this.minRange) &&
                                parseInt(rd[this.selFilter]) <= parseInt(this.maxRange)
                            );
                        } else {
                            if (this.minRange != "") {
                                return parseInt(rd[this.selFilter]) >= parseInt(this.minRange);
                            }
                            if (this.maxRange != "") {
                                return parseInt(rd[this.selFilter]) <= parseInt(this.maxRange);
                            }
                        }
                    });
                }
            }
        },
        //Get data Datewise
        filtDate(obj) {
            console.log("FilterDATE", obj, JSON.stringify(obj));
            this.ddate = new Date(obj.durDate);
            this.selRangeFilter = 0;
            this.minRange = '';
            this.maxRange = '';
            this.selFilter = "";
            this.searchText = "";
            this.getRawData();
        },
        filteredList(e) {
            console.log(e);
            this.$refs.mrkFilt.clearFilterData();
            this.selRangeFilter = 0;
            this.selFilter = "";
            var orgData = this.rawData;
            if (this.searchText === null || this.searchText === "") {
                this.rawData = this.searchData;
                return this.rawData;
            } else if (this.searchText.length <= 2) {
                this.rawData = this.searchData;
                return this.rawData;
            }
            if (this.searchText.length > 2 || e.keyCode === 13) {
                this.rawData = this.searchData.filter(rd => {
                    console.log(rd);
                    // rd.co_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
                    return (
                        (rd.companyname ?
                            rd.companyname.toLowerCase().includes(this.searchText.toLowerCase()) :
                            false)
                    );
                });
            }
        },
        clearData() {
            this.selRangeFilter = 0;
            this.selFilter = "";
            this.sectorname = "";
            this.searchText = "";
            this.rawData = this.searchData;
        }
    },
    mounted() {}
}


// WEBPACK FOOTER //
// ./src/assets/mixins/mrktcommon.js